import { render, staticRenderFns } from "./AccountForgotPassword.vue?vue&type=template&id=776938db&"
import script from "./AccountForgotPassword.vue?vue&type=script&lang=js&"
export * from "./AccountForgotPassword.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports